import { App } from 'antd';
import { MessageInstance } from 'antd/es/message/interface';
import { ArgsType } from '../../global';
import { useEffect } from 'react';

// 全局单例 api
let messageInstance: ReturnType<(typeof App)['useApp']>['message'];
let readyResolve: ((api: typeof messageInstance) => void) | null = null;
const readyPromise: Promise<typeof messageInstance> = new Promise(res => {
  readyResolve = res;
});

export const MessageHolder = () => {
  const { message } = App.useApp();
  useEffect(() => {
    messageInstance = message;
    // resolve 等待者
    readyResolve?.(message);
    return () => {
      messageInstance = null;
    };
  }, [message]);
  return <></>;
};

const mkFn = <T extends (...args: any) => any>(method: string) => {
  return (...args: ArgsType<T>) => {
    return messageInstance[method](...args) as ReturnType<T>;
  };
};

export const message = {
  info: mkFn<MessageInstance['info']>('info'),
  success: mkFn<MessageInstance['success']>('success'),
  error: mkFn<MessageInstance['error']>('error'),
  warning: mkFn<MessageInstance['warning']>('warning'),
  loading: mkFn<MessageInstance['loading']>('loading'),
  open: mkFn<MessageInstance['open']>('open'),
  destroy: mkFn<MessageInstance['destroy']>('destroy'),
};
